import BillingInfoModel from 'cio/models/billing-info';
import { PlanType } from 'cio/models/plan';

export default function getCurrentPlan(
  billingInfo: BillingInfoModel | undefined,
  planType: PlanType | undefined,
): string {
  let currentPlanInfo = '';
  if (billingInfo?.premiumTrial === true) {
    currentPlanInfo = 'Premium trial';
  } else if (billingInfo?.trial === true) {
    currentPlanInfo = 'Essentials trial';
  } else if (billingInfo?.activeSubscription === true) {
    currentPlanInfo = `${planType ?? 'Unknown'} subscription`;
  }
  return currentPlanInfo;
}
